import { TrackingInit } from '@vrplatform/data';
import {
  RootThemeProvider,
  V2Provider,
  type AppTheme,
} from '@vrplatform/theme';
import type { ReactNode } from 'react';
import { ErrorBoundary } from '../components';
import { useLegacyServiceWorkerCleanup } from './useLegacyServiceWorkerCleanup';

export const AppWrapper = ({
  children,
  themePrimaryColor,
}: {
  children: ReactNode;
  themePrimaryColor: AppTheme;
}) => {
  useLegacyServiceWorkerCleanup();

  return (
    <V2Provider>
      <RootThemeProvider themePrimaryColor={themePrimaryColor}>
        <ErrorBoundary>
          <TrackingInit>{children}</TrackingInit>
        </ErrorBoundary>
      </RootThemeProvider>
    </V2Provider>
  );
};
